import {
	type FrontendPlacementMessage,
	type AnyFrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import { PlacementFrontend } from '@post-office/browser--growth/confluence-side-nav';

import { type MessageTemplateContext } from '../../..';

import { LeftNavCtaMessage } from '../../../common/components/LeftNavCtaMessage';

import { type NextBestAction } from '@post-office/confluence-next-best-action';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

type MessageFrontendProps = MessageTemplateContext & {
	handleOnDismissed: () => void;
	onSideNavClick: (nextBestActionType: NextBestAction) => string | void | null;
};

// This is the Message Frontend. In this Placement we have render.Component which takes a React Component which will render your message in the Placement.
export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<MessageTemplateContext>(),
		Component: (props: MessageFrontendProps) => {
			return (
				<LeftNavCtaMessage
					handleOnDismissed={props.handleOnDismissed}
					onSideNavClick={props.onSideNavClick}
				/>
			);
		},
	},
});
